// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Tabs-module--cds--assistive-text--77036";
export var cdsVisuallyHidden = "Tabs-module--cds--visually-hidden--7e967";
export var dropdownWrapper = "Tabs-module--dropdownWrapper--58d5f";
export var hideFeedback = "Tabs-module--hide-feedback--d6440";
export var panel = "Tabs-module--panel--31531";
export var showFeedback = "Tabs-module--show-feedback--20bc7";
export var skeleton = "Tabs-module--skeleton--caf3d";
export var tab = "Tabs-module--tab--25b80";
export var tabList = "Tabs-module--tab-list--1a067";